<template>
  <div
    class="zm-steps"
    :class="[
       !simple && 'zm-steps--' + direction,
       simple && 'zm-steps--simple'
     ]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ZmSteps',

    props: {
      space: [Number, String],
      active: Number,
      direction: {
        type: String,
        default: 'horizontal'
      },
      alignCenter: Boolean,
      simple: Boolean,
      finishStatus: {
        type: String,
        default: 'finish'
      },
      processStatus: {
        type: String,
        default: 'process'
      }
    },

    data() {
      return {
        steps: [],
        stepOffset: 0
      };
    },

    methods: {},

    watch: {
      active(newVal, oldVal) {
        this.$emit('change', newVal, oldVal);
      },

      steps(steps) {
        steps.forEach((child, index) => {
          child.index = index;
        });
      }
    }
  };
</script>


<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(steps) {
    display: flex;

    @include m(simple) {
      padding: 13px 8%;
      border-radius: 4px;
      background: $--background-color-base;
    }

    @include m(horizontal) {
      white-space: nowrap;
    }

    @include m(vertical) {
      height: 100%;
      flex-flow: column;
    }
  }
</style>
